import { connect } from 'react-redux'
import pluralize from 'pluralize'
import { AddAnyStoreIcon } from 'components/icons'
import { DEVICE_PLATFORMS } from 'shared/constants'
import {
  getRegItemsOtherCount,
  getDevicePlatform,
  getBabylistButtonAdded,
} from 'registry/reducers'

import SetupGoal from './setup-goal'

function getText(state) {
  const count = getRegItemsOtherCount(state)
  const devicePlatform = getDevicePlatform(state)
  const babylistButtonInstalled = getBabylistButtonAdded(state)

  if (!babylistButtonInstalled && devicePlatform == DEVICE_PLATFORMS.desktop) {
    return 'You can add items from any store!'
  } else if (
    count == 0 &&
    babylistButtonInstalled &&
    devicePlatform == DEVICE_PLATFORMS.desktop
  ) {
    return 'Add an item with the Babylist button.'
  } else if (count == 0 && devicePlatform != DEVICE_PLATFORMS.desktop) {
    return 'Add an item with the Babylist app.'
  } else if (count > 0 && babylistButtonInstalled) {
    return `${count} ${pluralize('item', count)} added from stores!`
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <AddAnyStoreIcon alternate={ownProps.alternateIcon} />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
